import React, { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import classnames from 'classnames'
import { MuiThemeProvider } from 'material-ui/styles';
import { withStyles } from 'material-ui/styles';

import moment from 'moment';
import 'moment/locale/ru';

import Paper from 'material-ui/Paper';
import CodeInfo from 'components/CodeInfo';
import withAppStore from 'decorators/withAppStore';
import Loading from 'components/Loading';
import Message from 'components/Message';

import styles from 'styles/components/App';

export const SCROLL_ROOT_ID = 'scrollRoot';

@withStyles(styles)
@withAppStore
@observer
export default class App extends Component {

  @computed
  get isLoading() {
    return this.appStore.code && this.appStore.isLoading;
  }

  @computed
  get theme() {
    return this.appStore.theme;
  }

  @computed
  get hasError() {
    return this.appStore.hasLoadingError || !this.appStore.code;
  }

  @computed
  get errorMessage() {
    const { code, apiKey, hasApiError, isOriginError, isTooManyRequests } = this.appStore;

    if (!code) {
      return 'Не выбран код';
    } else if (!apiKey) {
      return 'Не указан параметр api-key';
    } else if(hasApiError) {
      if (isOriginError) {
        return 'Ключ API не соответствует домену, на котором размещен виджет';
      } 
      else if(isTooManyRequests) {
        return `Превышен лимит на количество запросов. Попробуйте ${moment().add(this.appStore.retryAfter, 'seconds').endOf().fromNow() }`;
      } else {
        return `Не удалось загрузить данные для кода ${this.appStore.code}`;
      }
    } else {
      return 'Произошла ошибка. Попробуйте перезагрузить виджет';
    }
  }

  componentWillMount() {
    moment.locale('ru');
    const preloader = document.getElementById('preloader');
    if (preloader) {
      preloader.style.display = 'none';
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={ this.theme }>
        <div className={ classnames(classes.root, classes.ready) } >
          <Paper elevation={0} square className={ classes.paper } >
            <CodeInfo />
            <Loading visible={ this.isLoading } />
            <Message visible={ this.hasError } text={ this.errorMessage } />
          </Paper>
        </div>
      </MuiThemeProvider>
    );
  }

}




// WEBPACK FOOTER //
// ./src/components/App.js